<template>
  <v-tabs
    v-model="active"
    centered
    slider-color="secondary"
    class="v-tabs-reports v-tabs-reports--drawer"
  >
    <v-tab
      v-for="item in ['summary', 'rides']"
      :key="item"
      ripple
      class="pl-0"
      style="width: 50%"
    >
      {{ $t(`${namespace}.${item}`) }}
    </v-tab>

    <v-tab-item>
      <v-card flat>
        <TabInfo :data="data" />
      </v-card>
    </v-tab-item>

    <v-tab-item>
      <v-card flat>
        <TabRides
          :data="data"
          :drawerType="drawerType"
          :filters="filters"
          @change="change"
        />
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import TabInfo from './TabInfo'
import TabRides from './TabRides'

export default {
  name: 'Tabs',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    drawerType: {
      type: String,
      required: true
    },
    filters: {
      type: Object
    }
  },
  components: {
    TabInfo,
    TabRides
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.financial.tabs',
      active: 0
    }
  },
  methods: {
    change (val) {
      this.$emit('change', val)
    }
  }
}
</script>
